import { useDataChange, useDataFormat } from 'Simple/Data.js'

export function useOnChangeSelectedRows(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'selected',
  })
  let selected = useDataFormat({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'selected_rows',
    format: list => list || [],
  })

  return function onChange(event) {
    change(next => {
      let selectedRowsSet = new Set(selected.map(itemToKey))
      let nextSelectedRows = event.api
        .getSelectedNodes()
        .map(item => item.data)
        .filter(Boolean)

      let matches = nextSelectedRows.map(item =>
        selectedRowsSet.has(itemToKey(item))
      )
      if (matches.length === selected.length) return

      if (next.merged !== null) {
        if (!next.merged.downloaded) {
          if (
            !window.confirm(
              `You have a generated statement that was printed but not downloaded. Reselecting rows will clear it and you'll start over. Are you sure you want to do this?`
            )
          ) {
            return
          }
        } else if (!next.merged.printed) {
          if (
            !window.confirm(
              `You have a generated statement that was downloaded but not printed. Reselecting rows will clear it and you'll start over. Are you sure you want to do this?`
            )
          ) {
            return
          }
        }
      }

      if (next.merged?.url) {
        try {
          URL.revokeObjectURL(next.merged.url)
        } catch (_) {}
      }
      next.merged = null
      next.selected_rows = nextSelectedRows
    })
  }
}

export function useOnIsRowSelected(props) {
  let selected = useDataFormat({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'selected_rows',
    format: list => new Set(list.map(itemToKey)),
  })

  return function onIsRowSelected(node) {
    return node.data && selected.has(itemToKey(node.data))
  }
}

function itemToKey(item) {
  return `${item.LOCATION_ID}-${item.PAYER_FIRST_NAME}-${item.PAYER_LAST_NAME}-${item.PATIENT_ID}`
}
